import RecurringTasksPage from './RecurringTasksPage';

export default RecurringTasksPage;
